import { ServiceErrorService } from '@/services/admin/ServiceErrorService'
import { QueryBuilder } from '@/utilities/queryBuilder'

export const namespaced = true

export const allowedFilters = ['title']

export const state = {
  service_errors: [],
  service_error: [],
  meta: null
}

export const mutations = {
  SET_SERVICE_ERRORS(state, serviceErrors) {
    state.service_errors = serviceErrors.data
    state.meta = serviceErrors.meta
  },
  SET_SERVICE_ERROR(state, serviceError) {
    state.service_error = serviceError
  },
  SET_FIXED(state, serviceErrors) {
    state.service_errors = serviceErrors
  }
}

export const actions = {
  getServiceErrors({ commit }, query) {
    return new Promise(resolve => {
      let serviceErrorService = new ServiceErrorService()

      let queryBuilder = new QueryBuilder()
        .where('relatable_id', query.relatable_id)
        .where('type', query.type)
        .where('fixed', query.fixed)
        .where('created_between', query.created_between)
        .where('farmer_id', query.farmer_id)
        .where('retailer_ids', query.retailer_ids)
        .where('sales_channels', query.sales_channels)
        .where('workflows', query.workflows)
        .page(query.page)
        .get()

      serviceErrorService.getServiceErrors(queryBuilder).then(response => {
        commit('SET_SERVICE_ERRORS', response)
        resolve(response.data)
      })
    })
  },
  getServiceError({ commit }, serviceError) {
    return new Promise(resolve => {
      let serviceErrorService = new ServiceErrorService()

      serviceErrorService.getServiceError(serviceError).then(response => {
        commit('SET_SERVICE_ERROR', response.data)
        resolve(response.data)
      })
    })
  },
  async markServiceError({ commit, state }, serviceError) {
    let serviceErrorService = new ServiceErrorService()
    const response = await serviceErrorService.markAsFixed(serviceError)
    const service_errors = state.service_errors.map(err => {
      if (err.id === serviceError) {
        err.fixed_by = response.data.fixed_by
        err.fixed = true
      }
      return err
    })
    commit('SET_SERVICE_ERRORS', { meta: state.meta, data: service_errors })
  },
  async unmarkServiceError({ commit }, serviceError) {
    let serviceErrorService = new ServiceErrorService()
    await serviceErrorService.unmarkAsFixed(serviceError)
    const service_errors = state.service_errors.map(err => {
      if (err.id === serviceError) {
        err.fixed = false
      }
      return err
    })
    commit('SET_SERVICE_ERRORS', { meta: state.meta, data: service_errors })
  },
  async markServiceErrors({ commit, state }, serviceError) {
    let serviceErrorService = new ServiceErrorService()
    const response = await serviceErrorService.markAsFixed(serviceError)
    const serviceErros = state.service_error.map(serviceError => {
      serviceError.fixed_by = response.data.fixed_by
      serviceError.fixed = true
      return serviceError
    })
    commit('SET_SERVICE_ERROR', serviceErros)
  },
  async unmarkServiceErrors({ commit, state }, serviceError) {
    let serviceErrorService = new ServiceErrorService()
    await serviceErrorService.unmarkAsFixed(serviceError)
    const serviceErros = state.service_error.map(serviceError => {
      serviceError.fixed_by = null
      serviceError.fixed = false
      return serviceError
    })
    commit('SET_SERVICE_ERROR', serviceErros)
  }
}
